import comp from '../components/barrel';
import svg from '../js/svg';
export default {
  party: null,
  loggedInRoleText: null,
  onbehalfAdvisorUuid: null,
  selectedOnbehalfAdvisor: null,

  async prepare() {
    const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
    if (loggedInUuid) {
      this.recipe.methods.push(
        await O.mPOST('users/get-user-details', {target_user_uuid: loggedInUuid})
      );
    }
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    const userDetails = data['users/get-user-details']?.data;
    this.loggedInRoleText = userDetails?.role_text || null;
    await this.loadPage();
  },

  isMarketerRole() {
    const role = (this.loggedInRoleText || '').trim().toLowerCase();
    return role === 'marketer';
  },

  async loadPage() {
    this.vars = this.vars || {};
    this.vars.advisor = '';
    this.vars.advisor_text = '';

    const isMarketer = this.isMarketerRole();

    if (isMarketer) {
      U.hide('step1');
      U.unhide('marketerAdvisorStep');
      await this.buildMarketerAdvisorSearch();
    } else {
      U.hide('marketerAdvisorStep');
      U.unhide('step1');
      const progressSteps = await comp.progressSteps(4);
      U.id('addAppCard').prepend(progressSteps);
    }
    
    //Build Single/Joint Toggle - defaulted to Single
    let sinJointToggle = await comp.toggleLarge('singleJointToggle', 0, 'Single', 'Joint', 'thsPage.singleJointToggle()');
    U.id('toggleDiv').appendChild(sinJointToggle);
    
    //Build Step 1 - Party 1 only
    let party1IDPass = await comp.inputIDPassport('party1IDPass', 1, '', 1);
    U.id('party1DivStep1').appendChild(party1IDPass);
    
    // Hide party2-5 on load (Single is default)
    for (let i = 2; i <= 5; i++) {
      const partyDiv = U.id(`party${i}DivStep1`);
      if (partyDiv) {
        partyDiv.classList.add('hide');
      }
    }
  },

  async singleJointToggle() {
    const isJoint = U.id('singleJointToggle').checked === true;
    
    // Change column 1 spacing (only for Step 1, not Step 2)
    const party1DivStep1 = U.id('party1DivStep1');
    party1DivStep1.classList.toggle('parties-single');

    // Handle party2-5
    for (let i = 2; i <= 5; i++) {
      let partyDivStep1 = U.id(`party${i}DivStep1`);
      
      // Create party div if it doesn't exist
      if (!partyDivStep1) {
        partyDivStep1 = document.createElement('div');
        partyDivStep1.id = `party${i}DivStep1`;
        partyDivStep1.className = 'hide';
        const partyH6 = document.createElement('h6');
        partyH6.innerHTML = `Party ${i}`;
        partyDivStep1.appendChild(partyH6);
        U.id('partiesStep1').appendChild(partyDivStep1);
      }
      
      // Show/hide based on toggle
      if (isJoint) {
        partyDivStep1.classList.remove('hide');
        // Create input if it doesn't exist - not required, but validates ID format if entered
        if (!U.id(`party${i}IDPass`)) {
          let partyIDPass = await comp.inputIDPassport(`party${i}IDPass`, 1, '', 0);
          partyDivStep1.appendChild(partyIDPass);
        }
      } else {
        partyDivStep1.classList.add('hide');
      }
      
      // Handle party2DivStep2
      const partyDivStep2 = U.id(`party${i}DivStep2`);
      if (partyDivStep2) {
        if (isJoint) {
          partyDivStep2.classList.remove('hide');
        } else {
          partyDivStep2.classList.add('hide');
        }
      }
    }
  },

  async step1Submit() {
    // Check if ID/Passport toggle btn and input field below is valid
    let isValid = await U.validateForm('partiesStep1');
    if (!isValid) {
      return;
    }

    // Validate party2-5 ID format if they have values (they're optional but must be valid if entered)
    const isJoint = U.id('singleJointToggle').checked === true;
    if (isJoint) {
      for (let i = 2; i <= 5; i++) {
        const partyInput = U.id(`party${i}IDPass`);
        if (partyInput && partyInput.value.trim()) {
          // Check if ID toggle is checked (ID Number mode)
          const idToggle = U.id(`party${i}IDPass_toggle`);
          if (idToggle && idToggle.checked) {
            // Validate ID number format
            if (!U.customValidations.isValidIdNumberZA(partyInput.value.trim())) {
              partyInput.classList.add('input-error');
              const fbElement = document.querySelector(`[fb-for="party${i}IDPass"]`);
              if (fbElement) {
                fbElement.textContent = 'Please enter a valid South African ID number';
              }
              return;
            }
          }
        }
      }
    }

    U.loaderBtn(1, 'step1Btn');

    // Set value of single/joint application to vars object
    const vars = {};
    vars.testament = isJoint ? 'joint' : 'single';
    vars.id_pass1 = U.id('party1IDPass').value;
    vars.id_pass2 = isJoint && U.id('party2IDPass') ? U.id('party2IDPass').value : '';
    vars.id_pass3 = isJoint && U.id('party3IDPass') ? U.id('party3IDPass').value : '';
    vars.id_pass4 = isJoint && U.id('party4IDPass') ? U.id('party4IDPass').value : '';
    vars.id_pass5 = isJoint && U.id('party5IDPass') ? U.id('party5IDPass').value : '';

    // Make api call to find out if ID/Pass is currently on record
    O.PREP([await O.mPOST('application/ver-user', vars)])
      .then(async (res) => {
        const responseData = res['application/ver-user'].data;

        // Check if data is an array and has items
        if (Array.isArray(responseData) && responseData.length > 0) {
          // Show informational pop-up about previous applications
          const heading = 'Previous Applications Found';
          const msg = 'There are previous applications or Wills on record. If you choose one of the previous records this will be marked as an amendment';
          comp.errorBox(heading, msg);
          
          // Display list of existing applications with checkboxes
          this.displayExistingApplications(responseData);
        } else {
          // No existing applications, proceed to step 2
          this.step1Submit2();
        }
      })
      .catch(() => {
        U.loaderBtn(0, 'step1Btn');
      });
  },

  // Add new method to display existing applications
  async displayExistingApplications(applications) {
    // Store applications array for later use
    this.existingApplications = applications;
    this.selectedApplication = null; // Reset selected application
    
    // Remove existing applications list if it exists
    const existingList = U.id('existingApplicationsList');
    if (existingList) {
      existingList.remove();
    }

    // Create container for the list
    const listContainer = U.divAtt('div', 'id', 'existingApplicationsList');
    listContainer.style.marginTop = '2rem';
    listContainer.style.marginBottom = '2rem';

    // Add heading
    const heading = U.divAtt('h5');
    heading.innerHTML = 'Existing Applications Found:';
    heading.style.marginBottom = '1rem';
    listContainer.appendChild(heading);

    // Create table for structured display
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';
    table.style.marginTop = '1rem';
    table.style.border = '1px solid #000';

    // Table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    const headers = ['Application', 'Created Date', 'Status', 'Imported Will Number', 'Party 1', 'Party 2', 'Party 3', 'Party 4', 'Party 5'];
    
    headers.forEach((headerText) => {
      const th = document.createElement('th');
      th.textContent = headerText;
      th.style.padding = '0.5rem';
      th.style.textAlign = 'center';
      th.style.border = '1px solid #000';
      th.style.borderBottom = '2px solid #000';
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Table body
    const tbody = document.createElement('tbody');
    
    for (const app of applications) {
      const row = document.createElement('tr');
      
      // Column 1: Application (checkbox + icon)
      const cell1 = document.createElement('td');
      cell1.style.padding = '0.5rem';
      cell1.style.border = '1px solid #000';
      cell1.style.textAlign = 'center';
      
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = `appCheckbox_${app.application_uuid}`;
      checkbox.name = `existingApp_${applications.indexOf(app)}`;
      checkbox.value = app.application_uuid;
      checkbox.style.marginRight = '0.5rem';
      checkbox.style.width = '20px';
      checkbox.style.height = '20px';
      checkbox.style.cursor = 'pointer';
      
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          const allCheckboxes = document.querySelectorAll('input[type="checkbox"][id^="appCheckbox_"]');
          allCheckboxes.forEach((cb) => {
            if (cb !== checkbox) {
              cb.checked = false;
            }
          });
          this.selectedApplication = app;
        } else {
          this.selectedApplication = null;
        }
        this.updateContinueButtonText();
      });
      
      cell1.appendChild(checkbox);
      
      const editAppLink = `O.PREP('ViewApplication', 'application_uuid=${app.application_uuid}')`;
      const linkSVG = svg.linkNewPage(editAppLink);
      cell1.appendChild(linkSVG);
      row.appendChild(cell1);

      // Column 2: Created Date
      const cell2 = document.createElement('td');
      cell2.style.padding = '0.5rem';
      cell2.style.border = '1px solid #000';
      cell2.textContent = new Date(app.created_date).toLocaleDateString();
      row.appendChild(cell2);

      // Column 3: Status
      const cell3 = document.createElement('td');
      cell3.style.padding = '0.5rem';
      cell3.style.border = '1px solid #000';
      const statusTag = await comp.statusTag(app.status);
      cell3.appendChild(statusTag);
      row.appendChild(cell3);

      // Column 4: Imported Will Number
      const cellImportWill = document.createElement('td');
      cellImportWill.style.padding = '0.5rem';
      cellImportWill.style.border = '1px solid #000';
      cellImportWill.textContent =
        app.importwillnumber != null && String(app.importwillnumber).trim() !== ''
          ? String(app.importwillnumber)
          : '-';
      row.appendChild(cellImportWill);

      // Column 5: Party 1
      const cell4 = document.createElement('td');
      cell4.style.padding = '0.5rem';
      cell4.style.border = '1px solid #000';
      const party1Name = app.party1f_name && app.party1s_name 
        ? `${app.party1f_name} ${app.party1s_name}` 
        : (app.party1f_name || app.party1s_name || '-');
      cell4.textContent = party1Name;
      row.appendChild(cell4);

      // Column 6: Party 2
      const cell5 = document.createElement('td');
      cell5.style.padding = '0.5rem';
      cell5.style.border = '1px solid #000';
      const party2Name = app.party2f_name && app.party2s_name 
        ? `${app.party2f_name} ${app.party2s_name}` 
        : (app.party2f_name || app.party2s_name || '-');
      cell5.textContent = party2Name;
      row.appendChild(cell5);

      // Column 7: Party 3
      const cell6 = document.createElement('td');
      cell6.style.padding = '0.5rem';
      cell6.style.border = '1px solid #000';
      const party3Name = app.party3f_name && app.party3s_name 
        ? `${app.party3f_name} ${app.party3s_name}` 
        : (app.party3f_name || app.party3s_name || '-');
      cell6.textContent = party3Name;
      row.appendChild(cell6);

      // Column 8: Party 4
      const cell7 = document.createElement('td');
      cell7.style.padding = '0.5rem';
      cell7.style.border = '1px solid #000';
      const party4Name = app.party4f_name && app.party4s_name 
        ? `${app.party4f_name} ${app.party4s_name}` 
        : (app.party4f_name || app.party4s_name || '-');
      cell7.textContent = party4Name;
      row.appendChild(cell7);

      // Column 9: Party 5
      const cell8 = document.createElement('td');
      cell8.style.padding = '0.5rem';
      cell8.style.border = '1px solid #000';
      const party5Name = app.party5f_name && app.party5s_name 
        ? `${app.party5f_name} ${app.party5s_name}` 
        : (app.party5f_name || app.party5s_name || '-');
      cell8.textContent = party5Name;
      row.appendChild(cell8);

      tbody.appendChild(row);
    }

    table.appendChild(tbody);
    listContainer.appendChild(table);

    // Insert the list container before the buttons in step1
    const step1Div = U.id('step1');
    const buttonsContainer = step1Div.querySelector('.flex.justify-center.items-center.mt-10');
    step1Div.insertBefore(listContainer, buttonsContainer);

    // Update the continue button text and onclick handler
    const step1Btn = U.id('step1Btn');
    if (step1Btn) {
      step1Btn.textContent = 'Continue as a new Will';
      // Update onclick to call step1Submit2 instead of step1Submit
      step1Btn.onclick = () => {
        this.step1Submit2();
      };
    }

    U.loaderBtn(0, 'step1Btn');
  },

  // Helper method to update the continue button text based on checkbox state
  updateContinueButtonText() {
    const step1Btn = U.id('step1Btn');
    if (!step1Btn) return;

    // Check if any checkbox is checked
    const checkboxes = document.querySelectorAll('input[type="checkbox"][id^="appCheckbox_"]');
    let anyChecked = false;
    
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        anyChecked = true;
      }
    });

    // Update button text based on checkbox state (use textContent to preserve onclick)
    if (anyChecked) {
      step1Btn.textContent = 'Continue as an amendment';
    } else {
      step1Btn.textContent = 'Continue as a new Will';
    }
  },

  // Helper method to parse full name into first name and surname
  parseName(fullName) {
    if (!fullName || !fullName.trim()) {
      return { f_name: '', s_name: '' };
    }
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 1) {
      return { f_name: parts[0], s_name: '' };
    }
    const s_name = parts.pop(); // Last part is surname
    const f_name = parts.join(' '); // Everything else is first name
    return { f_name, s_name };
  },

 

  async step1Submit2() {
    const vars = {};
    const isJoint = U.id('singleJointToggle').checked === true;
    vars.testament = isJoint ? 'joint' : 'single';
    vars.id_pass1 = U.id('party1IDPass').value;
    vars.id_pass2 = isJoint && U.id('party2IDPass') ? U.id('party2IDPass').value : '';
    vars.id_pass3 = isJoint && U.id('party3IDPass') ? U.id('party3IDPass').value : '';
    vars.id_pass4 = isJoint && U.id('party4IDPass') ? U.id('party4IDPass').value : '';
    vars.id_pass5 = isJoint && U.id('party5IDPass') ? U.id('party5IDPass').value : '';

    if (this.onbehalfAdvisorUuid) {
      vars.onbehalf_advisor_uuid = this.onbehalfAdvisorUuid;
    }

    O.PREP([await O.mPOST('application/ver-new-app', vars)])
      .then(async (res) => {
        const verifyData = res['application/ver-new-app'].data;
        this.party = verifyData.personal;
        const will = verifyData.will;
        const user = verifyData.user;

        // Check if imported will number is already on record (skip for amendments)
        if (will && will.will_nr && !this.selectedApplication) {
          try {
            const chkRes = await O.PREP([await O.mPOST('application/chk-importwillnumber', { importwillnumber: will.will_nr })]);
            const chkData = chkRes['application/chk-importwillnumber'];
            if (chkData && chkData.status === 'OK' && chkData.data && chkData.data.exists === true) {
              comp.errorBox('Cannot proceed', 'That will number is already on record');
              U.loaderBtn(0, 'step1Btn');
              return;
            }
          } catch (err) {
            U.loaderBtn(0, 'step1Btn');
            return;
          }
        }

        //   Build step 2 -----------
        this.buildStep2(this.party);
        U.hide('step1');
        U.unhide('step2');

        //   Build step 3 -----------
        if (will.will_nr) {
          const willNr = U.divAtt('h6');
          willNr.innerHTML = will.will_nr;
          U.id('willDiv').appendChild(willNr);
        }

        // Create a two-column container using divs with flexbox
        const containerDiv = U.divAtt('div', 'class', 'flex gap-8 mb-8');
        containerDiv.style.width = '100%';

        // Left column
        const leftColumn = U.divAtt('div', 'class', 'flex-1');
        const optionsArrr = ['New will', 'Revision of existing will'];
        const willTypeRadio = await comp.inputRadio('will_type', optionsArrr, 1);
        leftColumn.appendChild(willTypeRadio);

        // Right column
        const rightColumn = U.divAtt('div', 'class', 'flex-1');
        const offshore = await comp.inputCheckbox('offshore_will', will.offshore_will, 'Offshore will');
        rightColumn.appendChild(offshore);

        // Add empty spacing
        const spacer = U.divAtt('div', 'class', '');
        spacer.style.height = '1rem';
        spacer.style.margin = '1rem 0';
        rightColumn.appendChild(spacer);

        if (user.div_admin_yn) {
          const willNumber = await comp.inputText('will_number', will.will_nr || '', 'Will number', 0, null, '');
          // Force the container and elements to display as block/column
          const willNumberContainer = willNumber.querySelector('#will_numberDiv');
          if (willNumberContainer) {
            willNumberContainer.style.display = 'block';
          }
          const willNumberLabel = willNumber.querySelector('label');
          if (willNumberLabel) {
            willNumberLabel.style.display = 'block';
            willNumberLabel.style.marginBottom = '0.5rem';
          }
          const willNumberInput = willNumber.querySelector('#will_number');
          if (willNumberInput) {
            willNumberInput.style.display = 'block';
            willNumberInput.style.width = '120px';
          }
          rightColumn.appendChild(willNumber);
        }

        // Assemble the container
        containerDiv.appendChild(leftColumn);
        containerDiv.appendChild(rightColumn);

        // Append to willDiv
        U.id('willDiv').appendChild(containerDiv);

        //   Build step 4 -----------
        if (user.org_admin_yn) {
          let advisor = await comp.select('advisor', user.advisors, 'user_uuid', 'c_name', 'Advisor', 1);
          advisor.classList.toggle('parties-single');
          U.id('advisorsStep4Div').appendChild(advisor);
        } else if (user.div_admin_yn) {
          // Replace getCompaniesDD() with buildAdvisorSearch()
          this.buildAdvisorSearch();
        } else if (user.advisor_yn) {
          // SKIP step 4
          // Build New Progress Steps
          let oldProgressBar = U.id('progressSteps');
          U.id('addAppCard').removeChild(oldProgressBar);
          let progressSteps = await comp.progressSteps(3);
          U.id('addAppCard').prepend(progressSteps);
          // change step 2 next
          U.id('step3Btn').innerHTML = 'Add Application';
          U.id('step3Btn').onclick = () => thsPage.addApplication();
        } else if (this.onbehalfAdvisorUuid) {
          this.buildStep4AdvisorConfirm();
        }

        U.updateProgressSteps(2);

        U.loaderBtn(0, 'step1Btn');
      })
      .catch(() => {});
  },

  async buildStep2(personal) {
    // Check if this is an amendment (checkbox was selected)
    if (this.selectedApplication) {
      const selectedApp = this.selectedApplication;
      
      // Party 1
      const party1Name = selectedApp.party1f_name && selectedApp.party1s_name 
        ? `${selectedApp.party1f_name} ${selectedApp.party1s_name}` 
        : (selectedApp.party1f_name || selectedApp.party1s_name || 'N/A');
      U.id('party1Name').innerHTML = party1Name;
      
      // Party 2
      if (selectedApp.party2f_name || selectedApp.party2s_name) {
        U.id('party2DivStep2').classList.remove('hide');
        const party2Name = selectedApp.party2f_name && selectedApp.party2s_name 
          ? `${selectedApp.party2f_name} ${selectedApp.party2s_name}` 
          : (selectedApp.party2f_name || selectedApp.party2s_name || 'N/A');
        U.id('party2Name').innerHTML = party2Name;
      }
      
      // Party 3
      if (selectedApp.party3f_name || selectedApp.party3s_name) {
        let party3Div = U.id('party3DivStep2');
        if (!party3Div) {
          party3Div = document.createElement('div');
          party3Div.id = 'party3DivStep2';
          party3Div.className = 'parties-single';
          const party3H6 = document.createElement('h6');
          party3H6.innerHTML = 'Party 3';
          const party3NameDiv = document.createElement('div');
          party3NameDiv.id = 'party3Name';
          party3NameDiv.className = 'nameTag';
          const party3DetsDiv = document.createElement('div');
          party3DetsDiv.id = 'party3PersonalDets';
          party3Div.appendChild(party3H6);
          party3Div.appendChild(party3NameDiv);
          party3Div.appendChild(party3DetsDiv);
          U.id('partiesStep2').appendChild(party3Div);
        }
        party3Div.classList.remove('hide');
        const party3Name = selectedApp.party3f_name && selectedApp.party3s_name 
          ? `${selectedApp.party3f_name} ${selectedApp.party3s_name}` 
          : (selectedApp.party3f_name || selectedApp.party3s_name || 'N/A');
        U.id('party3Name').innerHTML = party3Name;
      }
      
      // Party 4
      if (selectedApp.party4f_name || selectedApp.party4s_name) {
        let party4Div = U.id('party4DivStep2');
        if (!party4Div) {
          party4Div = document.createElement('div');
          party4Div.id = 'party4DivStep2';
          party4Div.className = 'parties-single';
          const party4H6 = document.createElement('h6');
          party4H6.innerHTML = 'Party 4';
          const party4NameDiv = document.createElement('div');
          party4NameDiv.id = 'party4Name';
          party4NameDiv.className = 'nameTag';
          const party4DetsDiv = document.createElement('div');
          party4DetsDiv.id = 'party4PersonalDets';
          party4Div.appendChild(party4H6);
          party4Div.appendChild(party4NameDiv);
          party4Div.appendChild(party4DetsDiv);
          U.id('partiesStep2').appendChild(party4Div);
        }
        party4Div.classList.remove('hide');
        const party4Name = selectedApp.party4f_name && selectedApp.party4s_name 
          ? `${selectedApp.party4f_name} ${selectedApp.party4s_name}` 
          : (selectedApp.party4f_name || selectedApp.party4s_name || 'N/A');
        U.id('party4Name').innerHTML = party4Name;
      }
      
      // Party 5
      if (selectedApp.party5f_name || selectedApp.party5s_name) {
        let party5Div = U.id('party5DivStep2');
        if (!party5Div) {
          party5Div = document.createElement('div');
          party5Div.id = 'party5DivStep2';
          party5Div.className = 'parties-single';
          const party5H6 = document.createElement('h6');
          party5H6.innerHTML = 'Party 5';
          const party5NameDiv = document.createElement('div');
          party5NameDiv.id = 'party5Name';
          party5NameDiv.className = 'nameTag';
          const party5DetsDiv = document.createElement('div');
          party5DetsDiv.id = 'party5PersonalDets';
          party5Div.appendChild(party5H6);
          party5Div.appendChild(party5NameDiv);
          party5Div.appendChild(party5DetsDiv);
          U.id('partiesStep2').appendChild(party5Div);
        }
        party5Div.classList.remove('hide');
        const party5Name = selectedApp.party5f_name && selectedApp.party5s_name 
          ? `${selectedApp.party5f_name} ${selectedApp.party5s_name}` 
          : (selectedApp.party5f_name || selectedApp.party5s_name || 'N/A');
        U.id('party5Name').innerHTML = party5Name;
      }
    } else {
      // Original logic for new applications
      //PARTY 1
      if (personal.exi__id_pass1) {
        U.id('party1Name').innerHTML = `${personal.f_name1} ${personal.s_name1}`;
      } else {
        U.id('party1Name').innerHTML = `New (${U.id('party1IDPass').value})`;
        let party1name = await comp.inputText('p1_name', '', 'Name', 1);
        U.id('party1PersonalDets').appendChild(party1name);
        let party1surname = await comp.inputText('p1_s_name', '', 'Surname', 1);
        U.id('party1PersonalDets').appendChild(party1surname);
      }

      //PARTY 2
      if (personal.exi__id_pass2) {
        U.id('party2DivStep2').classList.remove('hide');
        U.id('party2Name').innerHTML = `${personal.f_name2} ${personal.s_name2}`;
      } else if (!personal.exi__id_pass2 && U.id('singleJointToggle').checked === true) {
        const party2Input = U.id('party2IDPass');
        if (party2Input && party2Input.value.trim()) {
          U.id('party2DivStep2').classList.remove('hide');
          U.id('party2Name').innerHTML = `New (${party2Input.value})`;
          let party2name = await comp.inputText('p2_name', '', 'Name', 1);
          U.id('party2PersonalDets').appendChild(party2name);
          let party2surname = await comp.inputText('p2_s_name', '', 'Surname', 1);
          U.id('party2PersonalDets').appendChild(party2surname);
        }
      }

      // PARTY 3-5 (only if Joint is selected and ID/Passport was entered)
      if (U.id('singleJointToggle').checked === true) {
        for (let i = 3; i <= 5; i++) {
          const partyInput = U.id(`party${i}IDPass`);
          if (partyInput && partyInput.value.trim()) {
            // Check if party exists in personal data
            const exiIdPass = personal[`exi__id_pass${i}`];
            let partyDiv = U.id(`party${i}DivStep2`);
            
            if (!partyDiv) {
              partyDiv = document.createElement('div');
              partyDiv.id = `party${i}DivStep2`;
              partyDiv.className = 'parties-single';
              const partyH6 = document.createElement('h6');
              partyH6.innerHTML = `Party ${i}`;
              const partyNameDiv = document.createElement('div');
              partyNameDiv.id = `party${i}Name`;
              partyNameDiv.className = 'nameTag';
              const partyDetsDiv = document.createElement('div');
              partyDetsDiv.id = `party${i}PersonalDets`;
              partyDiv.appendChild(partyH6);
              partyDiv.appendChild(partyNameDiv);
              partyDiv.appendChild(partyDetsDiv);
              U.id('partiesStep2').appendChild(partyDiv);
            }
            partyDiv.classList.remove('hide');
            
            if (exiIdPass) {
              U.id(`party${i}Name`).innerHTML = `${personal[`f_name${i}`]} ${personal[`s_name${i}`]}`;
            } else {
              U.id(`party${i}Name`).innerHTML = `New (${partyInput.value})`;
              let partyName = await comp.inputText(`p${i}_name`, '', 'Name', 1);
              U.id(`party${i}PersonalDets`).appendChild(partyName);
              let partySurname = await comp.inputText(`p${i}_s_name`, '', 'Surname', 1);
              U.id(`party${i}PersonalDets`).appendChild(partySurname);
            }
          }
        }
      }
    }
  },

  async step2Submit() {
    let isValid = await U.validateForm('partiesStep2');
    if (!isValid) {
      return;
    }

    //validate name and surname filled in if new
    U.hide('step2');
    U.unhide('step3');
    U.updateProgressSteps(3);
  },

  async step3Submit() {
    let isValid = await U.validateForm('willDiv');
    if (!isValid) {
      return;
    }

    // Check if will number is already on record (skip for amendments)
    const willNumberEl = U.id('will_number');
    const willNumber = willNumberEl ? willNumberEl.value.trim() : '';
    if (willNumber && !this.selectedApplication) {
      try {
        const chkRes = await O.PREP([await O.mPOST('application/chk-importwillnumber', { importwillnumber: willNumber })]);
        const chkData = chkRes['application/chk-importwillnumber'];
        if (chkData && chkData.status === 'OK' && chkData.data && chkData.data.exists === true) {
          comp.errorBox('Cannot proceed', 'That will number is already on record');
          return;
        }
      } catch (err) {
        comp.errorBox('Error', 'Failed to verify will number. Please try again.');
        return;
      }
    }

    U.hide('step3');
    U.unhide('step4');
    U.updateProgressSteps(4);
  },

  async buildMarketerAdvisorSearch() {
    const mount = U.id('marketerAdvisorFieldMount');
    if (!mount) return;
    mount.innerHTML = '';

    const advisorField = await comp.inputText('advisorDD', '', '', 0, '', 'Search advisor', false);
    mount.appendChild(advisorField);

    const advisorDD = U.id('advisorDD');
    if (advisorDD) {
      advisorDD.addEventListener('input', () => {
        clearTimeout(this.marketerAdvisorTimeout);
        this.marketerAdvisorTimeout = setTimeout(() => {
          this.getSuggestedAdvisors();
        }, 300);
      });
    }

    this.installMarketerAdvisorDocumentListener();
  },

  installMarketerAdvisorDocumentListener() {
    if (!this._boundMarketerAdvisorMousedown) {
      this._boundMarketerAdvisorMousedown = (e) => this._marketerAdvisorMousedown(e);
    }
    this.removeMarketerAdvisorDocumentListener();
    document.addEventListener('mousedown', this._boundMarketerAdvisorMousedown);
  },

  removeMarketerAdvisorDocumentListener() {
    if (this._boundMarketerAdvisorMousedown) {
      document.removeEventListener('mousedown', this._boundMarketerAdvisorMousedown);
    }
  },

  formatSelectedAdvisorLabel(row) {
    if (!row) return '';
    const name = `${row.f_name || ''} ${row.s_name || ''}`.trim() || (row.combo_text || '').trim();
    const broker = row.broker_number != null && String(row.broker_number).trim() !== ''
      ? String(row.broker_number).trim()
      : '';
    return broker ? `${name} (${broker})` : name;
  },

  renderSelectedAdvisorSummary(row) {
    const summaryEl = U.id('selectedAdvisorSummary');
    if (!summaryEl) return;

    const label = this.formatSelectedAdvisorLabel(row);
    if (!label) {
      summaryEl.innerHTML = '';
      summaryEl.classList.add('hide');
      return;
    }

    summaryEl.innerHTML = `<div class="nameTag">${label}</div>`;
    summaryEl.classList.remove('hide');
  },

  buildStep4AdvisorConfirm() {
    const grid = U.id('advisorsStep4Div');
    if (!grid) return;

    grid.innerHTML = '';
    grid.classList.add('advisors-step4-centered');

    const label =
      this.formatSelectedAdvisorLabel(this.selectedOnbehalfAdvisor) ||
      (this.vars.advisor_text || '').trim();

    const wrap = U.divAtt('div', 'class', 'flex flex-col items-center justify-center my-6 w-full');
    wrap.innerHTML = `<div class="nameTag">${label}</div>`;
    grid.appendChild(wrap);

    const advisorHidden = document.createElement('input');
    advisorHidden.type = 'hidden';
    advisorHidden.id = 'advisor';
    advisorHidden.name = 'advisor';
    advisorHidden.value = this.onbehalfAdvisorUuid || '';
    grid.appendChild(advisorHidden);
  },

  _marketerAdvisorMousedown(e) {
    const step = U.id('marketerAdvisorStep');
    if (!step || step.classList.contains('hide')) {
      return;
    }
    const suggestionItemParent = e.target.parentNode;
    const advisorDropdownEl = U.id('advisorListDropdownContainer');
    if (
      advisorDropdownEl &&
      e.target !== advisorDropdownEl &&
      suggestionItemParent &&
      suggestionItemParent.id !== 'advisorListDropdown'
    ) {
      advisorDropdownEl.remove();
    }
  },

  async getSuggestedAdvisors() {
    const advisorInputTextEl = U.id('advisorDD');
    if (!advisorInputTextEl) return;

    if (advisorInputTextEl.value === '') {
      this.vars.advisor = '';
      this.vars.advisor_text = '';
      return;
    }

    const existing = U.id('advisorListDropdownContainer');
    if (existing) {
      existing.remove();
    }

    const query = advisorInputTextEl.value.trim();
    if (query.length < 3) return;

    const vars = {};
    vars.search_filter = query;

    try {
      const res = await O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)]);
      const advisorListData = res['communal/advisor-autosuggest'].data;
      this.marketerAdvisorResults = Array.isArray(advisorListData) ? advisorListData : [];
      const advisorListDropdown = await comp.dataListDropdown({
        elID: 'advisorListDropdown',
        ddData: advisorListData,
        valueDataName: 'user_uuid',
        textDataName: 'combo_text',
        requiredYN: 0,
        onselect: 'handleAdvisorSelection',
        className: 'advisorSuggestionOption',
      });
      const ddDiv = U.id('advisorDDDiv');
      if (ddDiv) {
        ddDiv.appendChild(advisorListDropdown);
      }
    } catch (e) {
      /* ignore */
    }
  },

  async handleAdvisorSelection() {
    const advisorListDropdownEl = U.id('advisorListDropdownContainer');
    if (advisorListDropdownEl) {
      advisorListDropdownEl.remove();
    }

    if (this.vars.advisor_text && U.id('advisorDD')) {
      U.id('advisorDD').value = this.vars.advisor_text;
    }

    if (!this.isMarketerRole() || !this.vars.advisor) {
      return;
    }

    this.onbehalfAdvisorUuid = this.vars.advisor;

    const selectedRow = (this.marketerAdvisorResults || []).find(
      (row) => row.user_uuid === this.vars.advisor
    );
    this.selectedOnbehalfAdvisor =
      selectedRow ||
      {
        user_uuid: this.vars.advisor,
        combo_text: this.vars.advisor_text || '',
      };
    this.renderSelectedAdvisorSummary(this.selectedOnbehalfAdvisor);

    U.hide('marketerAdvisorStep');
    U.unhide('step1');

    this.removeMarketerAdvisorDocumentListener();

    if (!U.id('progressSteps')) {
      const progressSteps = await comp.progressSteps(4);
      U.id('addAppCard').prepend(progressSteps);
    }
  },

  // Build advisor search input
  async buildAdvisorSearch() {
    const grid1 = U.id('advisorsStep4Div');
    grid1.innerHTML = '';

    // Override any CSS grid styling and remove borders from the container
    grid1.style.display = 'block';
    grid1.style.grid = 'none';
    grid1.style.border = 'none';
    grid1.style.outline = 'none';
    grid1.style.boxShadow = 'none';
    grid1.style.backgroundColor = 'transparent';
    grid1.style.padding = '0';
    grid1.style.margin = '0';

    // Create a table with 2 columns and 2 rows
    const table = document.createElement('table');
    table.style.width = 'auto'; // Auto width instead of 100%
    table.style.marginTop = '2rem';
    table.style.marginLeft = '25%'; // Position 25% from the left edge
    table.style.marginRight = 'auto'; // Let it flow naturally to the right
    table.style.borderCollapse = 'collapse';
    table.style.border = 'none';
    table.style.borderSpacing = '0';
    table.style.backgroundColor = 'transparent';

    // Row 1: Search advisor label and input
    const row1 = document.createElement('tr');
    
    const labelCell1 = document.createElement('td');
    labelCell1.style.paddingRight = '1rem';
    labelCell1.style.textAlign = 'right';
    labelCell1.style.verticalAlign = 'middle';
    labelCell1.style.border = 'none';
    labelCell1.innerHTML = '<label>Search advisor</label>';
    
    const inputCell1 = document.createElement('td');
    inputCell1.style.verticalAlign = 'middle';
    inputCell1.style.border = 'none';

    // Create search input field - 20 characters wide
    // Pass empty string for placeholder (6th parameter) to avoid 'undefined'
    const searchInput = await comp.inputText('advisorSearch', '', '', 1, null, '');
    const searchInputDiv = searchInput.querySelector('#advisorSearchDiv');
    if (searchInputDiv) {
      // Remove label since we're using table layout
      const label = searchInputDiv.querySelector('label');
      if (label) {
        label.remove();
      }
      // Remove any borders/backgrounds from input-group
      searchInputDiv.style.border = 'none';
      searchInputDiv.style.outline = 'none';
      searchInputDiv.style.boxShadow = 'none';
      searchInputDiv.style.backgroundColor = 'transparent';
      searchInputDiv.style.padding = '0';
    }
    const searchInputField = searchInput.querySelector('#advisorSearch');
    if (searchInputField) {
      searchInputField.style.width = '200px'; // 20 characters wide
      searchInputField.style.maxLength = '20';
      // Remove placeholder attribute to ensure it's clean
      searchInputField.removeAttribute('placeholder');
      // Add event listener for search with debounce
      searchInputField.addEventListener('input', () => {
        this.searchAdvisors();
      });
    }
    inputCell1.appendChild(searchInput);

    row1.appendChild(labelCell1);
    row1.appendChild(inputCell1);

    // Row 2: Select advisor label and results table container
    const row2 = document.createElement('tr');
    
    const labelCell2 = document.createElement('td');
    labelCell2.style.paddingRight = '1rem';
    labelCell2.style.textAlign = 'right';
    labelCell2.style.verticalAlign = 'top';
    labelCell2.style.paddingTop = '1rem';
    labelCell2.style.border = 'none';
    labelCell2.innerHTML = '<label>Select advisor</label>';
    
    const dropdownCell2 = document.createElement('td');
    dropdownCell2.style.verticalAlign = 'top';
    dropdownCell2.style.paddingTop = '1rem';
    dropdownCell2.style.border = 'none';
    dropdownCell2.style.maxWidth = 'min(100%, 1200px)';

    // Create container for advisor table (initially hidden); hidden input holds UUID for validation/submit
    const advisorDropdownContainer = document.createElement('div');
    advisorDropdownContainer.id = 'advisorDropdownContainer';
    advisorDropdownContainer.style.display = 'none';
    advisorDropdownContainer.style.border = 'none';
    advisorDropdownContainer.style.outline = 'none';
    advisorDropdownContainer.style.backgroundColor = 'transparent';
    dropdownCell2.appendChild(advisorDropdownContainer);

    const advisorHidden = document.createElement('input');
    advisorHidden.type = 'hidden';
    advisorHidden.id = 'advisor';
    advisorHidden.name = 'advisor';
    advisorHidden.setAttribute('val', 'select');
    advisorHidden.required = true;
    advisorHidden.value = '';
    dropdownCell2.appendChild(advisorHidden);
    const advisorFb = document.createElement('span');
    advisorFb.setAttribute('fb-for', 'advisor');
    dropdownCell2.appendChild(advisorFb);

    row2.appendChild(labelCell2);
    row2.appendChild(dropdownCell2);

    // Append rows to table
    const tbody = document.createElement('tbody');
    tbody.style.border = 'none';
    tbody.appendChild(row1);
    tbody.appendChild(row2);
    table.appendChild(tbody);

    grid1.appendChild(table);

    // Initialize debounce timer variable
    this.searchTimeout = null;
    this.advisorSearchResults = [];
  },

  // Search advisors with debouncing
  async searchAdvisors() {
    const searchInput = U.id('advisorSearch');
    if (!searchInput) return;
    
    const searchValue = searchInput.value.trim();

    // Clear existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // If search value is less than 3 characters, hide results and return
    if (searchValue.length < 3) {
      const dropdownContainer = U.id('advisorDropdownContainer');
      const advisorHidden = U.id('advisor');
      if (advisorHidden) advisorHidden.value = '';
      if (dropdownContainer) {
        dropdownContainer.style.display = 'none';
        dropdownContainer.innerHTML = '';
      }
      return;
    }

    // Set new timeout for 1 second delay
    this.searchTimeout = setTimeout(async () => {
      try {
        // Get logged-in user UUID
        const {value: user_uuid} = await O.getCookie('ewttgpvwwkf');

        const vars = {};
        vars.search_filter = searchValue;
        vars.user_uuid = user_uuid;

        O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)])
          .then(async (res) => {
            const advisorResults = res['communal/advisor-autosuggest'].data;

            if (advisorResults && advisorResults.length > 0) {
              this.advisorSearchResults = advisorResults;

              const dropdownContainer = U.id('advisorDropdownContainer');
              dropdownContainer.innerHTML = '';

              const advisorHidden = U.id('advisor');
              if (advisorHidden) advisorHidden.value = '';

              const wrap = document.createElement('div');
              wrap.style.overflowX = 'auto';
              wrap.style.maxWidth = '100%';

              const tbl = document.createElement('table');
              tbl.style.borderCollapse = 'collapse';
              tbl.style.width = '100%';
              tbl.style.fontSize = '0.875rem';

              const thead = document.createElement('thead');
              const headRow = document.createElement('tr');
              const headerLabels = [
                '',
                'Associate advisor',
                'Advisor',
                'Broker number',
                'Division',
                'Division branch',
                'Organisation',
                'Organisation branch'
              ];
              headerLabels.forEach((label, hi) => {
                const th = document.createElement('th');
                th.textContent = label;
                th.style.textAlign = 'left';
                th.style.padding = '0.5rem 0.75rem';
                th.style.borderBottom = '1px solid rgba(0,0,0,0.15)';
                if (hi === 0) th.style.width = '2.5rem';
                headRow.appendChild(th);
              });
              thead.appendChild(headRow);
              tbl.appendChild(thead);

              const tbody = document.createElement('tbody');
              const cellText = (v) => {
                if (v == null) return '—';
                const s = String(v).trim();
                return s === '' ? '—' : s;
              };

              advisorResults.forEach((row, idx) => {
                const tr = document.createElement('tr');
                tr.style.borderBottom = '1px solid rgba(0,0,0,0.08)';

                const tdRadio = document.createElement('td');
                tdRadio.style.padding = '0.35rem 0.75rem';
                tdRadio.style.verticalAlign = 'middle';
                const radio = document.createElement('input');
                radio.type = 'radio';
                radio.name = 'advisorRadio';
                radio.value = row.user_uuid;
                radio.id = `advisorRadio_${idx}`;
                radio.addEventListener('change', () => {
                  const hid = U.id('advisor');
                  if (hid) hid.value = row.user_uuid;
                });
                tdRadio.appendChild(radio);
                tr.appendChild(tdRadio);

                [
                  cellText(row.associate_text),
                  cellText(row.combo_text),
                  cellText(row.broker_number),
                  cellText(row.divisionname),
                  cellText(row.divisionbranchname),
                  cellText(row.organistionname),
                  cellText(row.organistionbranchname)
                ].forEach((text) => {
                  const td = document.createElement('td');
                  td.textContent = text;
                  td.style.padding = '0.35rem 0.75rem';
                  td.style.verticalAlign = 'middle';
                  tr.appendChild(td);
                });

                tbody.appendChild(tr);
              });
              tbl.appendChild(tbody);
              wrap.appendChild(tbl);
              dropdownContainer.appendChild(wrap);
              dropdownContainer.style.display = 'block';
            } else {
              // No results
              const dropdownContainer = U.id('advisorDropdownContainer');
              const advisorHidden = U.id('advisor');
              if (advisorHidden) advisorHidden.value = '';
              if (dropdownContainer) {
                dropdownContainer.style.display = 'none';
                dropdownContainer.innerHTML = '';
              }
            }
          })
          .catch(() => {});
      } catch (err) {
      }
    }, 1000); // 1 second delay
  },

  async addApplication() {
    //VALIDATION HERE;

    let isValid = await U.validateForm('willDiv');
    if (!isValid) {
      return;
    }

    const step4El = U.id('step4');
    if (step4El && !step4El.classList.contains('hide')) {
      isValid = await U.validateForm('advisorsStep4Div');
      if (!isValid) {
        return;
      }
    }

    const vars = {};

    // Check if a checkbox is selected (amendment)
    if (this.selectedApplication) {
      // Add amended_uuid
      vars.amended_uuid = this.selectedApplication.application_uuid;
      
      // Use party data from selected application
      const selectedApp = this.selectedApplication;
      
      // Party 1 - always present
      const party1Name = this.parseName(selectedApp.party1);
      vars.party1 = {
        id_pass: selectedApp.party1pass || '',
        f_name: party1Name.f_name,
        s_name: party1Name.s_name,
      };

      // Party 2 - include if party2pass exists
      if (selectedApp.party2pass) {
        const party2Name = this.parseName(selectedApp.party2 || '');
        vars.party2 = {
          id_pass: selectedApp.party2pass,
          f_name: party2Name.f_name,
          s_name: party2Name.s_name,
        };
      }

      // Party 3 - include if party3pass exists
      if (selectedApp.party3pass) {
        const party3Name = this.parseName(selectedApp.party3 || '');
        vars.party3 = {
          id_pass: selectedApp.party3pass,
          f_name: party3Name.f_name,
          s_name: party3Name.s_name,
        };
      }

      // Party 4 - include if party4pass exists
      if (selectedApp.party4pass) {
        const party4Name = this.parseName(selectedApp.party4 || '');
        vars.party4 = {
          id_pass: selectedApp.party4pass,
          f_name: party4Name.f_name,
          s_name: party4Name.s_name,
        };
      }

      // Party 5 - include if party5pass exists
      if (selectedApp.party5pass) {
        const party5Name = this.parseName(selectedApp.party5 || '');
        vars.party5 = {
          id_pass: selectedApp.party5pass,
          f_name: party5Name.f_name,
          s_name: party5Name.s_name,
        };
      }
    } else {
      // Use existing logic for new application
      vars.party1 = {
        id_pass: U.id('party1IDPass').value,
        f_name: U.id('p1_name') ? U.id('p1_name').value : '',
        s_name: U.id('p1_s_name') ? U.id('p1_s_name').value : '',
      };


      // Add party2-5 if they have ID numbers filled in
      if (U.id('singleJointToggle').checked === true) {
        for (let i = 2; i <= 5; i++) {
          const partyInput = U.id(`party${i}IDPass`);
          if (partyInput && partyInput.value.trim()) {
            vars[`party${i}`] = {
              id_pass: partyInput.value,
              f_name: U.id(`p${i}_name`) ? U.id(`p${i}_name`).value : '',
              s_name: U.id(`p${i}_s_name`) ? U.id(`p${i}_s_name`).value : '',
            };
          }
        }
      }
    }

    const willTypeEl = document.querySelector('input[name="will_type"]:checked');
    if (!willTypeEl) {
      return;
    }
    vars.appType = willTypeEl.value;
    vars.offshore_yn = U.id('offshore_will').checked === true ? 1 : 0;
    vars.will_number = U.id('will_number') ? U.id('will_number').value.trim() : '';
    vars.advisor_uuid = U.id('advisor') ? U.id('advisor').value : '';

    // Check if will number is already on record (skip for amendments)
    if (vars.will_number && !this.selectedApplication) {
      try {
        const chkRes = await O.PREP([await O.mPOST('application/chk-importwillnumber', { importwillnumber: vars.will_number })]);
        const chkData = chkRes['application/chk-importwillnumber'];
        if (chkData && chkData.status === 'OK' && chkData.data && chkData.data.exists === true) {
          comp.errorBox('Cannot proceed', 'That will number is already on record');
          return;
        }
      } catch (err) {
        comp.errorBox('Error', 'Failed to verify will number. Please try again.');
        return;
      }
    }

    O.PREP([await O.mPOST('application/ins-new-app', vars)])
      .then(async (res) => {
        const msg = res['application/ins-new-app'].status;
        comp.toast(msg);

        O.PREP('ManageApplications');
        U.navSel('ManageApplications');
      })
      .catch(() => {});
  },

  cancelToManageApplications() {
    this.removeMarketerAdvisorDocumentListener();
    O.PREP('ManageApplications');
    U.navSel('ManageApplications');
  },

  cancelAppProgress() {
    this.removeMarketerAdvisorDocumentListener();
    const msg = 'Are you sure you would like to exit the add application process? <br> Progress will not be saved. Click Proceed.';
    const onclick = "O.PREP('ManageApplications')";
    comp.modal('Exit Add Application Process', msg, onclick);
  },
};
